import React, { useState } from 'react';
import IconSvg from '../IconSvg';
import { colors } from '../../../constants';

const InputToggleShowPassword = () => {
  const [showPass, setShowPass] = useState(false);

  const toggleShowHidePassword = e => {
    setShowPass(!showPass);
    const elem = e.closest('.ant-form-item-children').querySelector('input');
    elem.type = elem.type === 'password' ? 'text' : 'password';
  };

  return (
    <IconSvg
      size={16}
      marginTop="5px"
      color={colors.greyMid}
      hoverColor={colors.blueMed}
      type={showPass ? 'eye-invisible' : 'eye'}
      onClick={e => toggleShowHidePassword(e.target)}
    />
  );
};

export default InputToggleShowPassword;
